module.exports = __webpack_public_path__ + "img/bua_logo_network_symbol.ba69dcf1.svg";